import { useCallback } from 'react';
import cn from 'classnames';

import styles from './LettersFilter.module.scss';

export const letters = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export interface LettersFilterProps {
  selectedValue: string;
  onChange: (value: string) => void;
}

export default function LettersFilter(props: LettersFilterProps) {
  const { selectedValue, onChange } = props;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const filterValue = (e.target as HTMLButtonElement).value;
      filterValue && onChange(filterValue);
    },
    [onChange],
  );

  return (
    <div className={styles.lettersFilterWrapper}>
      <div className={styles.filterEl}>
        <button
          type="button"
          onClick={handleClick}
          value="All"
          className={cn({
            [styles.selectedEl]: selectedValue === 'All',
          })}
        >
          All
        </button>
      </div>
      {letters.map((letter) => (
        <div className={styles.filterEl} key={letter}>
          <button
            type="button"
            key={letter}
            onClick={handleClick}
            value={letter}
            className={cn({
              [styles.selectedEl]: selectedValue === letter,
            })}
          >
            {letter}
          </button>
        </div>
      ))}
    </div>
  );
}
